<template>
    <div>
        <FormPicker :trigger="trigger" :formType="'loginandsignupform'" :title="'Choose post with signup form'" />
    </div>
</template>

<script>
import RichSelect from "../../Global/RichSelect.vue"
import FormPicker from "./FormPicker.vue";

export default {
    components: {FormPicker, RichSelect },
    props: {
        trigger:  { type: Object, required: true }
    },
    methods: {
        /**
         * Update the selected text
         */
        pageSelected(selected) {
            this.trigger.settings.page_title = selected.text
        },
    }
}
</script>
